<template>
  <material-card
  :title="$t('globals.assign')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="assignment_turned_in"
  >
    <v-card-text>
      <DualListBoxSingleSelect
        :source="coverage"
        :destination="selected"
        :displayFunc1="(item) => `${translate2(item.Current, 'Name')}`"
        :displayFunc2="(item) => `${translate2(item.Current, 'Name')}`"
        @add-destination="onAddCoverage"
        @add-source="onRemoveCoverage"
      ></DualListBoxSingleSelect>
    </v-card-text>
    <v-card-actions>
      <v-btn
        v-if="showCancel"
        text
        :disabled="loading"
        @click="$emit('cancel')"
      >
        {{ $t("globals.cancel") }}
      </v-btn>
      <v-btn color="primary" :loading="loading" @click="save()">
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>

<script>
import DualListBoxSingleSelect from "../DualListboxSingleSelect";
import { mapActions, mapGetters } from "vuex";
import { translate2 } from "../../trans2";
import ErrorHandler from "../../components/ErrorHandler";

export default {
  components: { DualListBoxSingleSelect, ErrorHandler },
  props: {
    show: Boolean,
    showCancel: Boolean,
    item: Object,
  },
  data() {
    return {
      coverage: [],
      selected: [],
      loading: false,
      error: null,
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    item: {
      handler(v) {
        this.reset();
      },
    },
  },
  mounted() {
    this.reset();
  },
  methods: {
    ...mapActions("plansMembers", ["getCoverageIdentities"]),
    ...mapActions("downloadCenter", ["saveCoverageTileItem"]),
    translate2(item, field) {
      return translate2(item, field);
    },
    onAddCoverage({ selected }) {
      this.selected.push(selected[0]);
      this.coverage.splice(this.coverage.indexOf(selected[0]), 1);
    },
    onRemoveCoverage({ selected }) {
      this.coverage.push(selected[0]);
      this.selected.splice(this.selected.indexOf(selected[0]), 1);
    },
    async save() {
      this.loading = true;
      try {
        let item = JSON.parse(JSON.stringify(this.item));
        for (let row of item.CoverageTileItemCoverageTiles) {
          row.CoverageTileId = row.CoverageTile.Id;
          delete row.CoverageTile;
          delete row.selected;
        }
        delete item.ClassCoverageTileItem;
        item.JsonCoverageIds = JSON.stringify(this.selected.map((o) => o.Id));
        await this.withLoad(this.saveCoverageTileItem(item));
        this.$emit("update:item", this.item);
        this.$emit("reload-categories");
        this.$emit("update:show", false);
        this.$emit("saved");
      } catch (e) {
        this.error = e;
      } finally {
        this.loading = false;
      }
    },
    async reset() {
      if (this.item) {
        this.allCoverage = (await this.getCoverageIdentities({
          plan: this.selectedPlan.Id,
        })).value;
        let itemCoverage = JSON.parse(this.item.JsonCoverageIds);
        if (itemCoverage) {
          this.coverage = this.allCoverage.filter(
            (o) => itemCoverage.filter((c) => c === o.Id).length === 0
          );
          this.selected = this.allCoverage.filter(
            (o) => itemCoverage.filter((c) => c === o.Id).length > 0
          );
        } else {
          this.coverage = [].concat(this.allCoverage);
          this.selected = [];
        }
      }
    },
    async withLoad(promise) {
      this.error = null;
      this.loading = true;
      try {
        await promise;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
